import React from 'react';
import classnames from 'classnames';
import { Domingo } from '@fiverr-private/domingo';
import { atoms } from '@fiverr-private/theme';
import { getContext } from '@fiverr-private/fiverr_context';
import { mixpanel } from '@fiverr-private/obs';
import { useOpenSourcingDrawer } from '@fiverr-private/expert_sourcing_domain_selection_drawer_trigger';
import { rollouts as rolloutsPropType, user as userPropType } from '../../../PropTypes';
import { appTranslate } from '../../../i18n';
import Nav from '../../../lib/Nav';
import Link from '../Link';
import { User } from '../../../modern/types';

interface RolloutsContext {
    rollouts?: {
        inMarlinsEnableDesOnMpRollout?: boolean;
    };
    user: User;
}

export const LetUsFindFreelancerLink = (_props: unknown, { rollouts = {}, user }: RolloutsContext) => {
    const { userId, url } = getContext();
    const { openSourcingDrawer } = useOpenSourcingDrawer();
    const isInMarlinsEnableDesOnMp = rollouts?.inMarlinsEnableDesOnMpRollout === true;
    const showModal = isInMarlinsEnableDesOnMp && !user?.isSeller;

    const path = Domingo(url)
        .pro()
        .path(
            'fiverr_pro_product_page',
            { slug: 'expert-sourcing-services' },
            { query: { source: 'avatar_menu' } }
        ).url;

    const handleClick = (event: React.MouseEvent) => {
        mixpanel.track('Sourcing expert avatar menu clicked', {});

        if (showModal) {
            event.preventDefault();
            openSourcingDrawer({ source: 'avatar_menu' });
        }
    };

    const bqData = {
        group: 'header_clicks',
        type: 'clicked_header.clicked_on_sourcing_entry_point_avatar_menu_mp',
        user: {
            id: userId,
            navigation_mode: 'buying',
        },
    };

    return (
        <Nav.PopoverItem>
            <Link
                href={showModal ? undefined : path}
                rel="nofollow"
                onClick={handleClick}
                bigQueryData={bqData}
                className={classnames(atoms({ cursor: 'pointer' }), 'nav-link')}
            >
                {appTranslate('let_find_freelancer')}
            </Link>
        </Nav.PopoverItem>
    );
};

LetUsFindFreelancerLink.contextTypes = {
    rollouts: rolloutsPropType,
    user: userPropType,
};
